"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useA11yInfo = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _AccessibilityInfo = _interopRequireDefault(require("react-native-web/dist/cjs/exports/AccessibilityInfo"));
var _Platform = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Platform"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ScreenReaderContext = /*#__PURE__*/_react.default.createContext(false);
const ReducedMotionContext = /*#__PURE__*/_react.default.createContext(false);

// eslint-disable-next-line no-unused-vars
const A11yInfoProvider = /*#__PURE__*/_react.default.forwardRef((_ref, _) => {
  let {
    children
  } = _ref;
  const [reduceMotionEnabled, setReduceMotionEnabled] = _react.default.useState(false);
  const [screenReaderEnabled, setScreenReaderEnabled] = _react.default.useState(false);
  _react.default.useEffect(() => {
    if (process.env.NODE_ENV === 'test') {
      // On Jest these effects do nothing but can cause `act` state change warnings
      // and "...after the Jest environment has been torn down" errors, so skip them.
      return () => {};
    }
    const motionSubscription = _AccessibilityInfo.default.addEventListener('reduceMotionChanged', setReduceMotionEnabled);
    const setInitialA11yInfo = async () => {
      const [initialReduceMotionEnabled, initialScreenReaderEnabled] = await Promise.all([_AccessibilityInfo.default.isReduceMotionEnabled(), _AccessibilityInfo.default.isScreenReaderEnabled()]);

      // Browsers can't detect screen readers; in RNW isScreenReaderEnabled() is always `true`
      // https://github.com/necolas/react-native-web/blob/master/packages/react-native-web/src/exports/AccessibilityInfo/index.js#L14
      setScreenReaderEnabled(_Platform.default.OS !== 'web' && !!initialScreenReaderEnabled);

      // RNW does support isReduceMotionEnabled looking for 'prefers-reduced-motion' state
      setReduceMotionEnabled(!!initialReduceMotionEnabled);
    };
    if (_AccessibilityInfo.default.isReduceMotionEnabled && _AccessibilityInfo.default.isScreenReaderEnabled) {
      setInitialA11yInfo();
    }
    return () => {
      // From react-native 0.65, AccessibilityInfo.removeEventListener is deprecated for `remove` on addEventListener return value
      if (typeof motionSubscription?.remove === 'function') {
        motionSubscription?.remove();
      } else if (typeof _AccessibilityInfo.default.removeEventListener === 'function') {
        _AccessibilityInfo.default.removeEventListener('reduceMotionChanged', setReduceMotionEnabled);
      }
    };
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ReducedMotionContext.Provider, {
    value: reduceMotionEnabled,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ScreenReaderContext.Provider, {
      value: screenReaderEnabled,
      children: children
    })
  });
});
A11yInfoProvider.displayName = 'A11yInfoProvider';
A11yInfoProvider.propTypes = {
  children: _propTypes.default.node.isRequired
};
var _default = exports.default = A11yInfoProvider;
const useA11yInfo = () => {
  const screenReaderEnabled = _react.default.useContext(ScreenReaderContext);
  const reduceMotionEnabled = _react.default.useContext(ReducedMotionContext);
  return {
    reduceMotionEnabled,
    screenReaderEnabled
  };
};
exports.useA11yInfo = useA11yInfo;